import { render, staticRenderFns } from "./popAddOrderTips.vue?vue&type=template&id=5ca94cfb&scoped=true"
import script from "./popAddOrderTips.vue?vue&type=script&lang=js"
export * from "./popAddOrderTips.vue?vue&type=script&lang=js"
import style0 from "./popAddOrderTips.vue?vue&type=style&index=0&id=5ca94cfb&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ca94cfb",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/jenkins_home/workspace/Prod-五域创客/jh-5eck-web/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5ca94cfb')) {
      api.createRecord('5ca94cfb', component.options)
    } else {
      api.reload('5ca94cfb', component.options)
    }
    module.hot.accept("./popAddOrderTips.vue?vue&type=template&id=5ca94cfb&scoped=true", function () {
      api.rerender('5ca94cfb', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/customers/components/popAddOrderTips.vue"
export default component.exports